export default __webpack_public_path__ + "static/media/playBtn.c4b52ad2.svg";